import React, { useState } from 'react';
import CalendarAbsenceEventForm, {
	CalendarAbsenceEventDefaultValues,
	CalendarAbsenceEventFormValues,
} from './CalendarAbsenceEventForm';
import {
	CreateWorkplaceAbsenceInput,
	useCreateWorkplaceAbsenceMutation,
} from '../../../../graphql/graphql';
import useApiClient from '../../../Base/Hooks/useApiClient';
import Loading from '../../../../Components/Loading';
import { prepareAbsenceDateRange } from '../../Helpers/absenceDateRange.helper';

interface Props {
	isEdit?: boolean;
	onCreate: () => void;
	onUpdate: (values: CalendarAbsenceEventFormValues) => void;
	onRemove: () => void;
	defaultValues?: CalendarAbsenceEventDefaultValues;
	workplaceId: string;
}

const CalendarWorkplaceAbsenceEvent: React.FC<Props> = ({
	onCreate,
	onUpdate,
	onRemove,
	isEdit,
	defaultValues,
	workplaceId,
}) => {
	const { displayError, displayGQLError } = useApiClient();
	const [isLoading, setIsLoading] = useState(false);
	const [createWorkplaceAbsence] = useCreateWorkplaceAbsenceMutation();

	const handleCreate = async (values: CalendarAbsenceEventFormValues) => {
		setIsLoading(true);
		const { start, end } = prepareAbsenceDateRange(values);
		const { reason, allowContactInAbsence } = values;

		try {
			const input: CreateWorkplaceAbsenceInput = {
				start,
				end,
				description: reason,
				workplaceIds: [workplaceId],
				allowContactInAbsence,
			};

			const response = await createWorkplaceAbsence({ input });

			displayGQLError(response);
			if ('data' in response) {
				onCreate();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CalendarAbsenceEventForm
			onSubmit={isEdit ? onUpdate : handleCreate}
			onRemove={onRemove}
			defaultValues={defaultValues}
			isEdit={isEdit}
		/>
	);
};

export default CalendarWorkplaceAbsenceEvent;
